import { useEffect } from "react";

const descriptions = {
  "/": "GAMEDAY Holdings LLC is developing an integrated vision for human performance, "
    + "readiness, innovation, and recovery.",
  "/about": "Learn about GAMEDAY Holdings LLC and its development vision for connected "
    + "human-performance infrastructure.",
  "/vision": "Explore the GAMEDAY Holdings development vision for performance, mission "
    + "readiness, research, recovery, and innovation.",
  "/performance-world": "Discover GAMEDAY Performance World, a proposed ecosystem for sports "
    + "performance, recovery, science, and innovation.",
  "/military-performance-center":
    "Explore GAMEDAY's proposed Military Performance Center for human readiness, "
    + "immersive simulation, and resilience.",
  "/technology": "See GAMEDAY Holdings' technology exploration across performance analysis, "
    + "immersive environments, and smart facilities.",
  "/investment": "Explore GAMEDAY Holdings' investor opportunity and long-range approach to "
    + "human-performance infrastructure.",
  "/partnerships": "Connect with GAMEDAY Holdings on strategic partnerships across performance, "
    + "research, technology, and development.",
  "/news": "Read GAMEDAY Holdings company announcements, development updates, and "
    + "strategic partnership news.",
  "/contact": "Contact GAMEDAY Holdings LLC about strategic partnerships, investment, media, "
    + "and development conversations.",
};

function updateMeta(attribute, key, content) {
  let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

export default function usePageSeo(pathname, title) {
  useEffect(() => {
    const description = descriptions[pathname] || descriptions["/"];
    const protectedRoute = pathname.startsWith("/admin") || pathname === "/investor-portal";
    document.title = title;
    updateMeta("name", "description", description);
    updateMeta("property", "og:title", title);
    updateMeta("property", "og:description", description);
    updateMeta("name", "twitter:title", title);
    updateMeta("name", "twitter:description", description);
    updateMeta("name", "robots", protectedRoute ? "noindex, nofollow" : "index, follow");
  }, [pathname, title]);
}